import type { Competencia } from './contrato';

/**
 * Como o painel escreve uma competência.
 *
 * `MonthFilter` (design system) tem as mesmas duas funções, privadas: lá elas
 * servem ao botão do filtro, aqui servem ao eixo do gráfico e ao texto das
 * listas. Ficam neste módulo em vez de virarem exportação do componente de
 * filtro porque nada fora do painel precisa delas hoje — quando precisar, sobem
 * para `nucleo/formato/`.
 */

const NOMES_MES_CURTO = [
  'jan',
  'fev',
  'mar',
  'abr',
  'mai',
  'jun',
  'jul',
  'ago',
  'set',
  'out',
  'nov',
  'dez',
];

const NOMES_MES_LONGO = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

/** `2026-08` → `ago/26`. */
export function rotuloCurtoDaCompetencia(competencia: Competencia): string {
  const [ano, mes] = competencia.split('-').map(Number);
  if (!ano || !mes || mes < 1 || mes > 12) return competencia;
  return `${NOMES_MES_CURTO[mes - 1]}/${String(ano).slice(2)}`;
}

/** `2026-08` → `Agosto de 2026`. */
export function rotuloLongoDaCompetencia(competencia: Competencia): string {
  const [ano, mes] = competencia.split('-').map(Number);
  if (!ano || !mes || mes < 1 || mes > 12) return competencia;
  return `${NOMES_MES_LONGO[mes - 1]} de ${ano}`;
}
